
// import React from "react";
// import { motion } from "framer-motion";

// function HRMSFeatures() {
//   const features = [
//     {
//       title: "Centralized Employee Database",
//       description: "Store and manage all employee records in a secure, cloud-based database with easy search and update options.",
//       color: "#1E88E5",
//       direction: "left",
//       icon: "👥"
//     },
//     {
//       title: "Automated Payroll Processing",
//       description: "Process salaries, taxes, and deductions accurately with automated calculations and timely payouts.",
//       color: "#43A047",
//       direction: "right",
//       icon: "💰"
//     },
//     {
//       title: "Attendance & Leave Management",
//       description: "Track attendance, manage leave requests, and integrate with biometric or online check-in systems.",
//       color: "#FB8C00",
//       direction: "top",
//       icon: "📅"
//     },
//     {
//       title: "Performance & Appraisal Tracking",
//       description: "Set goals, track performance metrics, and run transparent appraisal processes for better talent management.",
//       color: "#8E24AA",
//       direction: "bottom",
//       icon: "📊"
//     },
//     {
//       title: "Recruitment & Onboarding",
//       description: "Streamline job postings, candidate tracking, and onboarding to ensure a smooth hiring experience.",
//       color: "#00ACC1",
//       direction: "left",
//       icon: "🔍"
//     },
//     {
//       title: "Compliance & Document Management",
//       description: "Maintain labor law compliance and manage HR documents securely with audit-ready storage.",
//       color: "#F4511E",
//       direction: "right",
//       icon: "📝"
//     },
//   ];

//   // Animation variants based on direction
//   const getCardVariants = (direction) => {
//     const distance = 100;
    
//     switch(direction) {
//       case "left":
//         return {
//           hidden: { opacity: 0, x: -distance },
//           visible: {
//             opacity: 1,
//             x: 0,
//             transition: { duration: 0.8, ease: "easeOut" }
//           }
//         };
//       case "right":
//         return {
//           hidden: { opacity: 0, x: distance },
//           visible: {
//             opacity: 1,
//             x: 0,
//             transition: { duration: 0.8, ease: "easeOut" }
//           }
//         };
//       case "top":
//         return {
//           hidden: { opacity: 0, y: -distance },
//           visible: {
//             opacity: 1,
//             y: 0,
//             transition: { duration: 0.8, ease: "easeOut" }
//           }
//         };
//       case "bottom":
//         return {
//           hidden: { opacity: 0, y: distance },
//           visible: {
//             opacity: 1,
//             y: 0,
//             transition: { duration: 0.8, ease: "easeOut" }
//           }
//         };
//       default:
//         return {
//           hidden: { opacity: 0, y: 50 },
//           visible: {
//             opacity: 1,
//             y: 0,
//             transition: { duration: 0.8, ease: "easeOut" }
//           }
//         };
//     }
//   };

//   const containerVariants = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: {
//         staggerChildren: 0.3,
//         duration: 0.5,
//       },
//     },
//   };

//   const styles = {
//     container: {
//       padding: "60px 20px",
//       textAlign: "center",
//       background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
//       fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//       minHeight: "100vh",
//     },
//     heading: {
//       fontSize: "clamp(28px, 5vw, 42px)",
//       marginBottom: "20px",
//       fontWeight: "700",
//       color: "#2c3e50",
//       textTransform: "uppercase",
//       letterSpacing: "1px",
//     },
//     subheading: {
//       fontSize: "clamp(16px, 3vw, 20px)",
//       marginBottom: "50px",
//       color: "#7f8c8d",
//       maxWidth: "800px",
//       margin: "0 auto 50px",
//       lineHeight: "1.6",
//       fontWeight: "500",
//     },
//     grid: {
//       display: "grid",
//       gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 350px), 1fr))",
//       gap: "30px",
//       maxWidth: "1200px",
//       margin: "0 auto",
//     },
//     card: {
//       background: "#fff",
//       borderRadius: "12px",
//       boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
//       padding: "30px 25px",
//       textAlign: "left",
//       transition: "all 0.3s ease",
//       borderLeft: "6px solid transparent",
//       minHeight: "280px",
//       cursor: "pointer",
//       display: "flex",
//       flexDirection: "column",
//       justifyContent: "space-between",
//     },
//     titleContainer: {
//       display: "flex",
//       alignItems: "center",
//       marginBottom: "15px",
//     },
//     icon: {
//       fontSize: "28px",
//       marginRight: "15px",
//     },
//     title: {
//       fontSize: "clamp(18px, 2.5vw, 22px)",
//       fontWeight: "600",
//       color: "#2c3e50",
//       lineHeight: "1.4",
//       margin: 0,
//     },
//     desc: {
//       fontSize: "clamp(14px, 2vw, 16px)",
//       lineHeight: "1.6",
//       color: "#5a6773",
//     },
//   };

//   return (
//     <div style={styles.container}>
//       <motion.h2
//         style={styles.heading}
//         initial={{ opacity: 0, y: -30 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         viewport={{ once: true, amount: 0.5 }}
//         transition={{ duration: 0.8, ease: "easeOut" }}
//       >
//         Reason Why Businesses Choose Envision HRMS
//       </motion.h2>
      
//       <motion.p 
//         style={styles.subheading}
//         initial={{ opacity: 0 }}
//         whileInView={{ opacity: 1 }}
//         viewport={{ once: true, amount: 0.5 }}
//         transition={{ duration: 0.8, delay: 0.3 }}
//       >
//         Streamline your HR operations with our comprehensive human resource management solution
//       </motion.p>

//       <motion.div
//         style={styles.grid}
//         variants={containerVariants}
//         initial="hidden"
//         whileInView="visible"
//         viewport={{ once: true, amount: 0.2 }}
//       >
//         {features.map((feature, index) => (
//           <motion.div
//             key={index}
//             variants={getCardVariants(feature.direction)}
//             style={{
//               ...styles.card,
//               borderLeft: `6px solid ${feature.color}`,
//             }}
//             whileHover={{
//               scale: 1.03,
//               boxShadow: "0 15px 35px rgba(0,0,0,0.12)",
//               transition: { duration: 0.2 },
//             }}
//           >
//             <div>
//               <div style={styles.titleContainer}>
//                 <span style={styles.icon}>{feature.icon}</span>
//                 <h3 style={styles.title}>{feature.title}</h3>
//               </div>
//               <p style={styles.desc}>{feature.description}</p>
//             </div>
//           </motion.div>
//         ))}
//       </motion.div>
//     </div>
//   );
// }

// export default HRMSFeatures;





import React from "react";
import { motion } from "framer-motion";

function BusinessBillingFeatures() {
const features = [
    {
      title: "Centralized Employee Database",
      description: "Store and manage all employee records in a secure, cloud-based database with easy search and update options.",
      color: "#1E88E5",
      direction: "left",
     
    },
    {
      title: "Automated Payroll Processing",
      description: "Process salaries, taxes, and deductions accurately with automated calculations and timely payouts.",
      color: "#43A047",
      direction: "right",
       
    },
    {
      title: "Attendance & Leave Management",
      description: "Track attendance, manage leave requests, and integrate with biometric or online check-in systems.",
      color: "#FB8C00",
      direction: "top",
       
    },
    {
      title: "Performance & Appraisal Tracking",
      description: "Set goals, track performance metrics, and run transparent appraisal processes for better talent management.",
      color: "#8E24AA",
      direction: "bottom",
       
    },
    {
      title: "Recruitment & Onboarding",
      description: "Streamline job postings, candidate tracking, and onboarding to ensure a smooth hiring experience.",
      color: "#00ACC1",
      direction: "left",
       
    },
    {
      title: "Compliance & Document Management",
      description: "Maintain labor law compliance and manage HR documents securely with audit-ready storage.",
      color: "#F4511E",
      direction: "right",
       
    },
  ];

  // Animation variants based on direction
  const getCardVariants = (direction) => {
    const distance = 100;
    
    switch(direction) {
      case "left":
        return {
          hidden: { opacity: 0, x: -distance },
          visible: {
            opacity: 1,
            x: 0,
            transition: { duration: 0.8, ease: "easeOut" }
          }
        };
      case "right":
        return {
          hidden: { opacity: 0, x: distance },
          visible: {
            opacity: 1,
            x: 0,
            transition: { duration: 0.8, ease: "easeOut" }
          }
        };
      case "top":
        return {
          hidden: { opacity: 0, y: -distance },
          visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.8, ease: "easeOut" }
          }
        };
      case "bottom":
        return {
          hidden: { opacity: 0, y: distance },
          visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.8, ease: "easeOut" }
          }
        };
      default:
        return {
          hidden: { opacity: 0, y: 50 },
          visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.8, ease: "easeOut" }
          }
        };
    }
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        duration: 0.5,
      },
    },
  };

  const styles = {
    container: {
      padding: "60px 20px",
      textAlign: "center",
      background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      minHeight: "100vh",
      maxWidth: "1200px",
      margin: "0 auto",
    },
    heading: {
      fontSize: "32px",
      marginBottom: "20px",
      fontWeight: "600",
      color: "black",
      letterSpacing: "0px",
    },
    subheading: {
      fontSize: "clamp(16px, 3vw, 20px)",
      marginBottom: "50px",
      color: "black",
      maxWidth: "800px",
      margin: "0 auto 50px",
      lineHeight: "1.6",
      fontWeight: "500",
      textAlign:"justify",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 350px), 1fr))",
      gap: "30px",
      maxWidth: "1200px",
      margin: "0 auto",
    },
    card: {
      background: "#fff",
      borderRadius: "12px",
      boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
      padding: "25px 20px",
      textAlign: "left",
      transition: "all 0.3s ease",
      borderLeft: "6px solid transparent",
      minHeight: "220px", // Reduced from 280px
      cursor: "pointer",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
    },
    titleContainer: {
      display: "flex",
      alignItems: "center",
      marginBottom: "12px", // Slightly reduced
    },
    icon: {
      fontSize: "28px",
      marginRight: "15px",
    },
    title: {
      fontSize: "clamp(18px, 2.5vw, 22px)",
      fontWeight: "600",
      color: "#2c3e50",
      lineHeight: "1.4",
      margin: 0,
    },
    desc: {
      fontSize: "clamp(14px, 2vw, 16px)",
      lineHeight: "1.6",
      color: "#5a6773",
    },
  };

  return (
    <div style={styles.container}>
      <motion.h2
        style={styles.heading}
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        Six Reason Why Businesses Choose Envision HRMS
      </motion.h2>
      
      <motion.p 
        style={styles.subheading}
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 0.8, delay: 0.3 }}
      >
        Streamline your HR operations with our comprehensive human resource management solution
      </motion.p>

      <motion.div
        style={styles.grid}
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        {features.map((feature, index) => (
          <motion.div
            key={index}
            variants={getCardVariants(feature.direction)}
            style={{
              ...styles.card,
              borderLeft: `6px solid ${feature.color}`,
            }}
            whileHover={{
              scale: 1.03,
              boxShadow: "0 15px 35px rgba(0,0,0,0.12)",
              transition: { duration: 0.2 },
            }}
          >
            <div>
              <div style={styles.titleContainer}>
                <span style={styles.icon}>{feature.icon}</span>
                <h3 style={styles.title}>{feature.title}</h3>
              </div>
              <p style={styles.desc}>{feature.description}</p>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
}

export default BusinessBillingFeatures;